import { render, staticRenderFns } from "./strengths.vue?vue&type=template&id=76bb8bd5&scoped=true"
import script from "./strengths.vue?vue&type=script&lang=js"
export * from "./strengths.vue?vue&type=script&lang=js"
import style0 from "./strengths.vue?vue&type=style&index=0&id=76bb8bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb8bd5",
  null
  
)

export default component.exports